import { render, staticRenderFns } from "./CourseDetailCard.vue?vue&type=template&id=1cbce4fa&scoped=true"
import script from "./CourseDetailCard.vue?vue&type=script&lang=js"
export * from "./CourseDetailCard.vue?vue&type=script&lang=js"
import style0 from "./CourseDetailCard.vue?vue&type=style&index=0&id=1cbce4fa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cbce4fa",
  null
  
)

export default component.exports